import { combineReducers } from 'redux';
import { user } from './redux/user';
import { menu } from './redux/menu';
import { modalDetail } from './redux/modal/build-modal-detail';

// 公告管理 - 公告编辑
import { publicNotices } from './redux/public/notices';
import { publicSystemNotices } from './redux/public/systemNotice';

// 帮助手册管理 - 公告编辑
import { publicHelpManual } from './redux/public/helpManual';
// 系统管理->菜单管理
import { MenuManagement } from './redux/system/menuManagement';
// 帮助手册管理 - 公告发送
import { publicHelpManualSend } from './redux/public/helpManualSend';
import { publicBannerUp } from './redux/public/bannerUp';
import { publicTestAction } from './redux/public/testAction';
import { publicMessage } from './redux/public/message';
// 消息管理->短信推送
import { publicAboutus } from './redux/public/aboutus';
import { systemRole } from './redux/system/role';
import { systemMenu } from './redux/system/menu';
import { systemSysParam } from './redux/system/sysParam';
import { systemUpdate } from './redux/system/update';
import { systemStrategy } from './redux/system/strategy';
import { systemUser } from './redux/system/user';
import { systemPwdReset } from './redux/system/pwdReset';
import { systemLog } from './redux/system/log';
// 数据字典管理
import { DataDict } from './redux/system/dataDict';
// 文章管理/组别管理
import { systemArticleClass } from './redux/system/articleClass';
// 文章管理-客服管理
import { customerService } from './redux/system/customerService';
// 文章管理 banner管理
import { publicBanner } from './redux/public/banner';
// 文章管理 首页导航栏
import { publicHomeMenu } from './redux/public/homeMenu';
// 系统管理-社区管理
import { SystemCommunity } from './redux/system/community';
// 系统管理-项目预告管理
import { SystemProjectTrailer } from './redux/system/projectTrailer';
// 业务管理
// 会员管理-会员查询
import { bizUserUser } from '@redux/biz/user/user/user';
// kyc审核
import { bizUserKycCheck } from './redux/biz/user/kycCheck/kycCheck';
// 企业kyc审核
import { bizUserKycCheckEnterprise } from './redux/biz/user/kycCheckEnterprise/kycCheckEnterprise';
// 激活码管理
import { bizActiveCodeActivityCode } from '@redux/biz/user/activityCode/activityCode.js';
// 会员管理-游离会员
import { bizFreeUser } from './redux/biz/user/freeUser/freeUser';
// 会员管理-会员等级
import { bizUserLevel } from './redux/biz/user/level/level';
// 会员管理-会员标签
import { bizUserLabel } from './redux/biz/user/label/label';
// 会员管理-会员自动打标签任务
import { bizUserAutoLabelTask } from './redux/biz/user/label/auto-label-task';
// 会员管理-会员等级规则
import { bizUserLevelRules } from './redux/biz/user/levelRules/levelRules';
// 会员管理-钻石赠送规则
import { bizUserDiamondRules } from './redux/biz/user/diamondRules/diamondRules';
// 客户管理-推荐设置
import { bizUserInviteConfig } from './redux/biz/user/inviteConfig';
import { bizChannelTransferOrder } from './redux/biz/channelSys/channelTransferOrder';
// 财务管理
// 会员资产
import { financeMemberAccount } from './redux/finance/member/account';
import { financeMemberAccountBill } from './redux/finance/member/account-bill';
// 提现管理
import { financeWithdrawalApproval } from './redux/finance/withdrawal/approval';
import { financeWithdrawalRecord } from './redux/finance/withdrawal/record';
import { financeWithdrawalCompleted } from './redux/finance/withdrawal/completed';
import { financeWithdrawalNopass } from './redux/finance/withdrawal/nopass';
import { financeWithdrawalRejected } from './redux/finance/withdrawal/rejected';
import { financeWithdrawalRelus } from './redux/finance/withdrawal/rules';
import { financeWithdrawalCenter } from './redux/finance/withdrawal/center';
// 充币管理
import { financeRechargeQuery } from './redux/finance/recharge/query';
import { financeRechargeGJQuery } from './redux/finance/recharge/gjquery';
// 转账管理
import { financeTransferApproval } from './redux/finance/transfer/approval';
import { financeTransferCompleted } from './redux/finance/transfer/completed';
import { financeTransferNopass } from './redux/finance/transfer/nopass';
import { financeTransferRules } from './redux/finance/transfer/rules';

// 业务管理-推荐分佣
import { bizIncomeTeam } from '@redux/biz/income/team';
import { bizIncomeRules } from '@redux/biz/income/rules';

// 业务管理-推荐分佣-每日分佣分布
import { bizIncomeDailyUser } from '@redux/biz/income/dailyUser';

// 业务管理-推荐分佣-每日社区查询
import { bizIncomeIncome } from './redux/biz/income/income';

// 业务管理-推荐分佣-分成规则
import { bizIncomeConfig } from './redux/biz/income/config';

// 出纳管理-持币快照
import { financeMemberAccountSnapshot } from './redux/finance/member/accountSnapshot';

// 版本日志管理
import { systemVersionLog } from './redux/system/versionLog';

// 统计分析
import { statisticsDailyReport } from './redux/statistics/dailyReport';
import { statisticsSales } from './redux/statistics/sales';

// 业务管理--评论管理
import { bizCommentKeywords } from './redux/biz/comment/keywords';
import { bizCommentCheck } from './redux/biz/comment/check';
import { bizCommentList } from './redux/biz/comment/list';
import { bizCommentReport } from './redux/biz/comment/report';

// 业务管理-帖子管理
import { bizPostList } from './redux/biz/post/list';
import { bizPostReport } from './redux/biz/post/report';

// NFT管理-时刻管理
import { NFTCollectionCollection } from './redux/NFT/collection/collection';
import { NFTCollectionModelList } from './redux/NFT/collection/model-list';
import { NFTCollectionModel } from './redux/NFT/collection/model';
import { NFTCollectionModelCirculatio } from './redux/NFT/collection/circulatioRrecord';
import { NFTCollectionCategory } from './redux/NFT/collection/category';
import { NFTCollectionCategoryList } from './redux/NFT/collection/category-list';
import { NFTCollectionConfig } from './redux/NFT/collection/config';
import { NFTCollectionTransferRecord } from './redux/NFT/collection/transferRecord';
import { NFTCollectionLockActivities } from './redux/NFT/collection/lockActivities';
import { NFTCollectionLockRecords } from './redux/NFT/collection/lockRecords';
import { NFTCollectionDelisted } from './redux/NFT/collection/delisted';

// NFT管理-出售管理
import { NFTOrderBidding } from './redux/NFT/order/bidding';
import { NFTOrderBiddingRecord } from './redux/NFT/order/bidding-record';
import { NFTOrderBiddingDelayRecord } from './redux/NFT/order/bidding-delayRecord';
import { NFTOrderBiddingBondRecord } from './redux/NFT/order/bidding-bondRecord';
import { NFTOrderBiddingConfig } from './redux/NFT/order/bidding-config';
import { NFTOrderBuyoutPrice } from './redux/NFT/order/buyoutPrice';
import { NFTOrderBuyoutPriceOrder } from './redux/NFT/order/buyoutPrice-order';
import { NFTOrderBuyoutPriceConfig } from './redux/NFT/order/buyoutPrice-config';
import { NFTOrderCollectionPack } from './redux/NFT/order/collectionPack';
import { NFTOrderCollectionPackOrder } from './redux/NFT/order/collectionPack-order';
import { NFTOrderYkjjjOrder } from './redux/NFT/order/ykjjjOrder';

// NFT管理-挑战管理
import { NFTChallengeList } from './redux/NFT/challenge/list';
import { NFTChallengeInProgress } from '@redux/NFT/challenge/inProgress';
import { NFTChallengeAwardProvide } from '@redux/NFT/challenge/awardProvide';
import { NFTChallengeComponentCollection } from '@redux/NFT/challenge/component/collection';
import { NFTChallengeComponentAwardWinningRecord } from '@redux/NFT/challenge/component/awardWinningRecord';
import { NFTChallengeFail } from '@redux/NFT/challenge/fail';
import { NFTChallengeHistory } from '@redux/NFT/challenge/history';
import { NFTChallengeChallenge } from '@redux/NFT/challenge/challenge';
import { NFTChallengeCategory } from '@redux/NFT/challenge/category';
import { NFTChallengeOrder } from '@redux/NFT/challenge/order';
import { NFTChallengeEntity } from '@redux/NFT/challenge/entity';

import { publicDetailList } from '@redux/public/publicDetailList';

// NFT管理-导出管理
import { NFTExportList } from './redux/NFT/export/export';
import { NFTExportBlockChainAddressM } from './redux/NFT/export/blockChainAddressM';
import { NFTExportBeOnTheAir } from './redux/NFT/export/beOnTheAir';
import { NFTExportToBeBroadcast } from './redux/NFT/export/toBeBroadcast';
import { NFTExportNopass } from './redux/NFT/export/nopass';
import { NFTExportSuccess } from './redux/NFT/export/success';
import { NFTExportFail } from './redux/NFT/export/fail';

// NFT管理-铸币管理
import { NFTContractTokenList } from './redux/NFT/contractToken/contractToken';
import { NFTContractTokenBlockChainAddressS } from './redux/NFT/contractToken/blockChainAddressS';
import { NFTContractTokenBlockChainAddressW } from './redux/NFT/contractToken/blockChainAddressW';

// NFT管理-导出管理
import { NFTImportList } from './redux/NFT/import/import';
import { NFTImportAddress } from './redux/NFT/import/address';

// NFT管理-关注管理
import { NFTFollowCollection } from './redux/NFT/follow/collection';
import { NFTFollowCollectionPack } from './redux/NFT/follow/collectionPack';

// 时刻管理-百变大咖
import { NFTChangeSeries } from './redux/NFT/change/series';
import { NFTChangeType } from './redux/NFT/change/type';
import { NFTChangeModule } from './redux/NFT/change/module';
import { NFTChangeRecommendModule } from './redux/NFT/change/recommendModule';
import { NFTChangeConfig } from './redux/NFT/change/config';

// 时刻管理-百变大咖
import { NFTBlindBoxBlindBoxModule } from './redux/NFT/blindBox/blindBoxModule';
import { NFTBlindBoxBlindKnapsack } from './redux/NFT/blindBox/knapsack';
import { NFTBlindBoxConfig } from './redux/NFT/blindBox/config';

// 业务管理-宝藏计划
import { bizTreasurePlan } from './redux/biz/treasurePlan/treasurePlan';
import { bizTreasurePlanDetail } from './redux/biz/treasurePlan/treasurePlanDetail';

// 时刻管理-藏品销售
import { NFTCollectionWorks } from './redux/NFT/collection/works';
import { NFTCollectionPeriod } from './redux/NFT/collection/period';
import { NFTCollectionBuyOrder } from './redux/NFT/collection/buyOrder';
import { NFTCollectionLuckDrawSale } from '@redux/NFT/collection/luckDrawSale';
import { NFTCollectionLuckDrawSaleJoinRecord } from '@redux/NFT/collection/luckDrawSaleJoinRecord';

// 藏品回收
import { NFTCollectionRecycling } from '@redux/NFT/collection/recycling';

// 元宇宙
import { NFTUniversePic } from '@redux/NFT/universe/universePic';

// 机构管理-兑换码管理
import { NFTCollectionExchangeCode } from '@redux/NFT/collection/exchangeCode';
export default combineReducers({
  publicAboutus,
  user,
  menu,
  modalDetail,
  systemRole,
  systemMenu,
  systemUser,
  systemPwdReset,
  systemSysParam,
  systemUpdate,
  systemStrategy,
  systemLog,
  // 公告管理 - 公告编辑
  publicNotices,
  publicSystemNotices,
  publicHelpManual,
  publicHelpManualSend,
  publicTestAction,
  publicBanner,
  publicBannerUp,
  publicHomeMenu,
  SystemCommunity,
  SystemProjectTrailer,
  publicMessage,
  DataDict,
  MenuManagement,
  systemArticleClass,
  customerService,
  bizUserUser,
  bizUserLevel,
  bizUserLabel,
  bizUserAutoLabelTask,
  bizUserLevelRules,
  bizUserKycCheck,
  bizUserKycCheckEnterprise,
  bizActiveCodeActivityCode,
  bizFreeUser,
  bizUserDiamondRules,
  bizUserInviteConfig,
  bizChannelTransferOrder,
  financeMemberAccount,
  financeMemberAccountBill,
  financeWithdrawalApproval,
  financeWithdrawalRecord,
  financeWithdrawalCompleted,
  financeWithdrawalNopass,
  financeWithdrawalRejected,
  financeWithdrawalRelus,
  financeWithdrawalCenter,
  financeRechargeQuery,
  financeRechargeGJQuery,
  financeTransferApproval,
  financeTransferCompleted,
  financeTransferNopass,
  financeTransferRules,
  bizIncomeTeam,
  bizIncomeRules,
  bizIncomeDailyUser,
  bizIncomeIncome,
  bizIncomeConfig,
  financeMemberAccountSnapshot,
  systemVersionLog,
  statisticsDailyReport,
  // 销售统计
  statisticsSales,
  // 业务管理 评论管理
  bizCommentKeywords,
  bizCommentCheck,
  bizCommentList,
  bizCommentReport,
  // 业务管理-帖子管理
  bizPostList,
  bizPostReport,
  // NFT管理-时刻管理
  NFTCollectionCollection,
  NFTCollectionModelList,
  NFTCollectionModel,
  NFTCollectionModelCirculatio,
  NFTCollectionCategory,
  NFTCollectionCategoryList,
  NFTCollectionConfig,
  NFTCollectionTransferRecord,
  NFTCollectionLockActivities,
  NFTCollectionLockRecords,
  NFTCollectionDelisted,
  // NFT管理-出售管理
  NFTOrderBidding,
  NFTOrderBiddingRecord,
  NFTOrderBiddingDelayRecord,
  NFTOrderBiddingBondRecord,
  NFTOrderBiddingConfig,
  NFTOrderBuyoutPrice,
  NFTOrderBuyoutPriceOrder,
  NFTOrderBuyoutPriceConfig,
  NFTOrderCollectionPack,
  NFTOrderCollectionPackOrder,
  NFTOrderYkjjjOrder,
  // NFT管理-挑战管理
  NFTChallengeList,
  NFTChallengeInProgress,
  NFTChallengeAwardProvide,
  NFTChallengeComponentCollection,
  NFTChallengeComponentAwardWinningRecord,
  NFTChallengeFail,
  NFTChallengeHistory,
  publicDetailList,
  NFTChallengeChallenge,
  NFTChallengeCategory,
  NFTChallengeOrder,
  NFTChallengeEntity,
  // NFT管理-导出管理
  NFTExportList,
  NFTExportBlockChainAddressM,
  NFTExportBeOnTheAir,
  NFTExportToBeBroadcast,
  NFTExportNopass,
  NFTExportSuccess,
  NFTExportFail,
  // NFT管理-铸币管理
  NFTContractTokenList,
  NFTContractTokenBlockChainAddressS,
  NFTContractTokenBlockChainAddressW,
  // NFT管理-导入管理
  NFTImportList,
  NFTImportAddress,
  // NFT管理-关注管理
  NFTFollowCollection,
  NFTFollowCollectionPack,
  // 时刻管理-百变大咖
  NFTChangeSeries,
  NFTChangeType,
  NFTChangeModule,
  NFTChangeRecommendModule,
  NFTChangeConfig,
  // 时刻管理-盲盒管理
  NFTBlindBoxBlindBoxModule,
  NFTBlindBoxBlindKnapsack,
  NFTBlindBoxConfig,
  // 业务管理-宝藏计划
  bizTreasurePlan,
  bizTreasurePlanDetail,
  // 时刻管理-藏品销售
  NFTCollectionWorks,
  NFTCollectionPeriod,
  NFTCollectionBuyOrder,
  NFTCollectionRecycling,
  NFTCollectionLuckDrawSale,
  NFTCollectionLuckDrawSaleJoinRecord,
  // 元宇宙
  NFTUniversePic,
  NFTCollectionExchangeCode
});
